module.exports = __webpack_public_path__ + "img/events.9f2b9259.png";